import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import {
    STATUS_CLAIM_UNCLAIMED,
    STATUS_CLAIM_AWAITING,
    STATUS_CLAIM_SOLVE,
} from '../../api/constants'

const ClaimStatus = ({ status }) => {
    switch (status) {
        case STATUS_CLAIM_UNCLAIMED:
            return <FormattedMessage defaultMessage='No hay reclamaciones' />
        case STATUS_CLAIM_AWAITING:
            return <FormattedMessage defaultMessage='En espera' />
        case STATUS_CLAIM_SOLVE:
            return <FormattedMessage defaultMessage='Reclamación resuelta satisfactoriamente' />
        default:
            return <FormattedMessage defaultMessage='Reclamación denegada' />
    }
}

ClaimStatus.propTypes = {
    status: PropTypes.number.isRequired,
}

export default ClaimStatus
